<div class="force-to-the-bottom">
    <tag-input [maxItems]="maxItems" inputClass="tag-input-width" placeholder="+{{ 'Tag' | translate }}"
        secondaryPlaceholder="{{ 'Enter a new tag' | translate }}" [(ngModel)]="items" (onAdd)="onAdd($event)"
        (onRemove)="onRemove($event)" [onlyFromAutocomplete]="true">
        <tag-input-dropdown [showDropdownIfEmpty]="true" [autocompleteItems]="roles" [dynamicUpdate]="true"
            [keepOpen]="false">
        </tag-input-dropdown>
    </tag-input>
</div>